import { render } from "./OurPurpose.vue?vue&type=template&id=cdac59fa&scoped=true"
import script from "./OurPurpose.vue?vue&type=script&lang=js"
export * from "./OurPurpose.vue?vue&type=script&lang=js"

import "./OurPurpose.vue?vue&type=style&index=0&id=cdac59fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdac59fa"]])

export default __exports__